// extracted by mini-css-extract-plugin
module.exports = {"form":"SendBudgetForm_form__3NEr6","field":"SendBudgetForm_field__Ioece","propertyLabel":"SendBudgetForm_propertyLabel__2W-yG","buttons":"SendBudgetForm_buttons__hLbiz"};